/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPlaidAccessDetailsForCustomerRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetPlaidAccessDetailsForCustomer.pb'
import {GetPlaidAccessDetailsForCustomerResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetPlaidAccessDetailsForCustomer.pb'


export const getPlaidAccessDetailsForCustomer = (request: GetPlaidAccessDetailsForCustomerRequest, options?: CashRequestOptions) => post<GetPlaidAccessDetailsForCustomerRequest, GetPlaidAccessDetailsForCustomerResponse>("/2.0/cash/get-plaid-access-details-for-customer", request, {...options, rejectOnError: true })